import React from "react";

const MainTitleSubtitle = ({
  type,
  titles,
  subtitles,
  textStyle = {},
  titleStyle = {},
  subtitleStyle = {},
}) => {
  return (
    <div style={{ width: "100%" }}>
      <p
        style={{
          fontFamily: "Roboto",
          fontWeight: 700,
          fontSize: "2em",
          color: "white",
          textShadow: "1px 1px 1px #ADBEBA",
          ...(subtitles && subtitles.length > 0
            ? { marginBottom: "0.5em" }
            : {}),
          ...textStyle,
          ...titleStyle,
        }}
      >
        {titles[0]}
      </p>
      {Array.isArray(subtitles) && subtitles.length > 0 && (
        <h1
          style={{
            fontFamily: "Roboto",
            fontWeight: 400,
            fontSize: "1.5em",
            color: "white",
            ...(subtitles.length > 0 ? { marginTop: "0.5em" } : {}),
            ...textStyle,
            ...subtitleStyle,
          }}
        >
          {subtitles[0]}
        </h1>
      )}
    </div>
  );
};

export default MainTitleSubtitle;
